export const Mutations = {
  setConsent: "setConsent"
};
